import React from 'react'

export const NistGapLine = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="4" viewBox="0 0 26 4" fill="none">
      <path d="M1 2.25L25 1.75" stroke="#FF7738" strokeWidth="3" strokeDasharray="4 4" />
    </svg>
  )
}
